import React from 'react';
import { Lock, Unlock } from 'lucide-react';
import './PrivateMediaBadge.css';

// Candado de visibilidad para archivos "de una pieza" renderizados desde React (a diferencia de las
// imágenes embebidas en comentarios/docs, que reciben el candado como HTML+CSS armado por el
// backend — ver `resolve()` en `shared/storage/embeddedContent.js` — porque ahí el frontend
// solo recibe un string de HTML, no puede montar un componente). Construido originalmente para
// documentos de clientes y adjuntos de dataindex, reusable acá.
const PRIVATE_TOOLTIP = 'Los documentos son privados y no se recomienda compartir el link del fichero, se tiene que descargar y compartir el fichero.';
const PUBLIC_TOOLTIP = 'Contenido público';

export default function PrivateMediaBadge({ access, onToggle, disabled = false, children, className = '' }) {
    const isPrivate = access === 'private';
    const title = isPrivate ? PRIVATE_TOOLTIP : PUBLIC_TOOLTIP;

    return (
        <span className={`private-media-badge ${className}`} data-access={access} title={title}>
            {children}
            <button
                type="button"
                className="private-media-badge-toggle"
                aria-label="Alternar visibilidad"
                disabled={disabled || !onToggle}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onToggle?.(isPrivate ? 'public' : 'private');
                }}
            >
                {isPrivate ? <Lock size={12} /> : <Unlock size={12} />}
            </button>
        </span>
    );
}
